import styled from 'styled-components';
import { Btn } from 'components';

export const MemberList = styled.div``;

export const BtnAddMemberWrapper = styled.div`
    width: 100px;
`;

export const BtnAddMember = styled(Btn)`
    display: flex;
    align-items: center;
`;

export const SvgWrapper = styled.div`
    
    margin-right: 4px;
`;

export const BtnMoreWrapper = styled.div`
    text-align: center;
    padding: 16px 0;
    margin-top: 36px;
`;

export const BtnMore = styled(Btn)`
    width: 180px;
`;